export const TEXT = {
  BUTTON_FACEBOOK: {id: 'signup.facebook.cta'},
};
